import Vue from 'vue'
import Router from 'vue-router'
import SignIn from '@/components/Common/SignIn' // 后台管理平台登录页面
import Public from '@/components/Common/Public' // 后台管理平台公共页面
import HousingManagementFullRent from '@/components/Menu/HousingManagementFullRent' // 房源管理(整租)
import HousingManagementSchool from '@/components/Menu/HousingManagementSchool' // 房源管理(学生公寓)
import HousingManagementShortLease from '@/components/Menu/HousingManagementShortLease' // 房源管理(短租)
import HousingManagementOperation from '@/components/Menu/HousingManagementOperation' // 新建/编辑房源管理
import HousingManagementOperationSchool from '@/components/Menu/HousingManagementOperationSchool' // 新建/编辑学生公寓管理
import ConsultationRecord from '@/components/Menu/ConsultationRecord' // 咨询记录
import UserManagement from '@/components/Menu/UserManagement' // 用户管理
import PlatformDiscountManagement from '@/components/Menu/PlatformDiscountManagement' // 平台优惠管理
import PlatformDiscountManagementOperation from '@/components/Menu/PlatformDiscountManagementOperation' // 新建/编辑平台优惠管理
import ListingSortingManagement from '@/components/Menu/ListingSortingManagement' // 房源排序管理
import ListingSortingManagementOperation from '@/components/Menu/ListingSortingManagementOperation' // 新建/编辑房源排序管理
import UrbanManagement from '@/components/Menu/UrbanManagement' // 城市管理
import UrbanManagementOperation from '@/components/Menu/UrbanManagementOperation' // 新建/编辑城市管理
import SchoolManagement from '@/components/Menu/SchoolManagement' // 学校管理
import SchoolManagementOperation from '@/components/Menu/SchoolManagementOperation' // 新建/编辑学校管理
import RegionalManagement from '@/components/Menu/RegionalManagement' // 区域管理
import RegionalManagementOperation from '@/components/Menu/RegionalManagementOperation' // 新建/编辑区域管理
import LocationManagement from '@/components/Menu/LocationManagement' // 地标管理
import LocationManagementOperation from '@/components/Menu/LocationManagementOperation' // 新建/编辑地标管理
import FacilitiesManagement from '@/components/Menu/FacilitiesManagement' // 地标管理
import FacilitiesManagementOperation from '@/components/Menu/FacilitiesManagementOperation' // 新建/编辑地标管理
import LabelManagement from '@/components/Menu/LabelManagement' // 标签管理
import LabelManagementOperation from '@/components/Menu/LabelManagementOperation' // 新建/编辑标签管理
import CostManagement from '@/components/Menu/CostManagement' // 费用明细管理
import CostManagementOperation from '@/components/Menu/CostManagementOperation' // 新建/编辑费用明细管理
import HousingInformationManagement from '@/components/Menu/HousingInformationManagement' // 房屋信息管理
import HousingInformationManagementOperation from '@/components/Menu/HousingInformationManagementOperation' // 新建/编辑房屋信息管理
import BannerManagement from '@/components/Menu/BannerManagement' // Banner管理
import BannerManagementOperation from '@/components/Menu/BannerManagementOperation' // 新建/编辑Banner管理
import WeChatManagement from '@/components/Menu/WeChatManagement' // 顾问微信二维码管理
import administratorsManagement from '@/components/Menu/administratorsManagement' // 管理员管理
import administratorsManagementOperation from '@/components/Menu/administratorsManagementOperation' // 新增/编辑管理员管理
import RelocationServiceManagement from '@/components/Menu/RelocationServiceManagement' // 安家服务
import RelocationServiceManagementOperation from '@/components/Menu/RelocationServiceManagementOperation' // 新增/编辑安家服务
import Message from '@/components/Menu/Message' // 聊天信息
Vue.use(Router)
//获取原型对象上的replace函数
const originalReplace = Router.prototype.replace
//修改原型对象中的replace方法
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  //base: '/',
  //mode:'history',// history 模式，去#号
  routes: [
    {
      path: '/',
      name: 'SignIn',
      component: SignIn,
    },
    {
      path:'/',
      name: 'Public',
      component: Public,
      redirect: '/HousingManagementFullRent',
      children:[
		  { // 首页-房源管理(整租)
          path: '/HousingManagementFullRent',
          name: 'HousingManagementFullRent',
          component: HousingManagementFullRent,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 首页-房源管理(学生公寓)
          path: '/HousingManagementSchool',
          name: 'HousingManagementSchool',
          component: HousingManagementSchool,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 首页-房源管理(短租)
          path: '/HousingManagementShortLease',
          name: 'HousingManagementShortLease',
          component: HousingManagementShortLease,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 新增/编辑房源管理
          path: '/HousingManagementOperation',
          name: 'HousingManagementOperation',
          component: HousingManagementOperation,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 新增/编辑学生公寓管理
          path: '/HousingManagementOperationSchool',
          name: 'HousingManagementOperationSchool',
          component: HousingManagementOperationSchool,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 咨询记录
          path: '/ConsultationRecord',
          name: 'ConsultationRecord',
          component: ConsultationRecord,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 用户管理
          path: '/UserManagement',
          name: 'UserManagement',
          component: UserManagement,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 平台优惠管理
          path: '/PlatformDiscountManagement',
          name: 'PlatformDiscountManagement',
          component: PlatformDiscountManagement,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 新建/编辑平台优惠管理
          path: '/PlatformDiscountManagementOperation',
          name: 'PlatformDiscountManagementOperation',
          component: PlatformDiscountManagementOperation,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 房源排序管理
          path: '/ListingSortingManagement',
          name: 'ListingSortingManagement',
          component: ListingSortingManagement,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 新建/编辑房源排序管理
          path: '/ListingSortingManagementOperation',
          name: 'ListingSortingManagementOperation',
          component: ListingSortingManagementOperation,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 城市管理
          path: '/UrbanManagement',
          name: 'UrbanManagement',
          component: UrbanManagement,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 新增/编辑城市管理
          path: '/UrbanManagementOperation',
          name: 'UrbanManagementOperation',
          component: UrbanManagementOperation,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 学校管理
          path: '/SchoolManagement',
          name: 'SchoolManagement',
          component: SchoolManagement,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 新增/编辑学校管理
          path: '/SchoolManagementOperation',
          name: 'SchoolManagementOperation',
          component: SchoolManagementOperation,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 区域管理
          path: '/RegionalManagement',
          name: 'RegionalManagement',
          component: RegionalManagement,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 新增/编辑区域管理
          path: '/RegionalManagementOperation',
          name: 'RegionalManagementOperation',
          component: RegionalManagementOperation,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 地标管理
          path: '/LocationManagement',
          name: 'LocationManagement',
          component: LocationManagement,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 新建/编辑地标管理
          path: '/LocationManagementOperation',
          name: 'LocationManagementOperation',
          component: LocationManagementOperation,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 设施管理
          path: '/FacilitiesManagement',
          name: 'FacilitiesManagement',
          component: FacilitiesManagement,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 新建/编辑设施管理
          path: '/FacilitiesManagementOperation',
          name: 'FacilitiesManagementOperation',
          component: FacilitiesManagementOperation,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 标签管理
          path: '/LabelManagement',
          name: 'LabelManagement',
          component: LabelManagement,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 新建/编辑标签管理
          path: '/LabelManagementOperation',
          name: 'LabelManagementOperation',
          component: LabelManagementOperation,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 费用明细管理
          path: '/CostManagement',
          name: 'CostManagement',
          component: CostManagement,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 房屋信息管理
          path: '/HousingInformationManagement',
          name: 'HousingInformationManagement',
          component: HousingInformationManagement,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 新建/编辑房屋信息
          path: '/HousingInformationManagementOperation',
          name: 'HousingInformationManagementOperation',
          component: HousingInformationManagementOperation,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 新建/编辑费用明细管理
          path: '/CostManagementOperation',
          name: 'CostManagementOperation',
          component: CostManagementOperation,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // Banner管理
          path: '/BannerManagement',
          name: 'BannerManagement',
          component: BannerManagement,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 新建/编辑Banner管理
          path: '/BannerManagementOperation',
          name: 'BannerManagementOperation',
          component: BannerManagementOperation,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 顾问微信二维码管理
          path: '/WeChatManagement',
          name: 'WeChatManagement',
          component: WeChatManagement,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 管理员管理
          path: '/administratorsManagement',
          name: 'administratorsManagement',
          component: administratorsManagement,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 新增/编辑管理员管理
          path: '/administratorsManagementOperation',
          name: 'administratorsManagementOperation',
          component: administratorsManagementOperation,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 安家服务
          path: '/RelocationServiceManagement',
          name: 'RelocationServiceManagement',
          component: RelocationServiceManagement,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        },
        { // 新增/编辑安家服务
          path: '/RelocationServiceManagementOperation',
          name: 'RelocationServiceManagementOperation',
          component: RelocationServiceManagementOperation,
          meta: {
            needLogin: true // 需要加校检判断的路由
          },
        }
      ]
    },
    { // 聊天
      path: '/Message',
      name: 'Message',
      component: Message,
      meta: {
        needLogin: true // 需要加校检判断的路由
      },
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js